import { ChangeDetectorRef, Component, Input } from "@angular/core";

@Component({
    selector: 'app-clipboard-icon',
    templateUrl: './clipboard-icon.component.html',
    styleUrls: ['./clipboard-icon.component.css'],
    standalone: false
})
export class ClipboardIconComponent {
  @Input() width!: string;
  @Input() height!: string;
  @Input() color!: string;

  state: 'copy' | 'check' = 'copy';

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  toggleState(): void {
    this.state = this.state === 'copy' ? 'check' : 'copy';
    setTimeout(() => {
      this.state = 'copy';
      this.cdr.detectChanges();
    }, 2000);
  };
};
